window.mika = {}
app = window.mika

# ##### APP VARS #####




# ##### HELPERS #####
app.hasClass = (elem, className) ->
	return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ')

app.checkURLParams = ->
	url = window.location.href
	queryStart = url.indexOf("?") + 1
	queryEnd   = url.indexOf("#") + 1 || url.length + 1
	query = url.slice(queryStart, queryEnd - 1)
	pairs = query.replace(/\+/g, " ").split("&")
	parms = {}

	if (query == url || query == "") 
		return

	for i in [0..pairs.length-1]
		nv = pairs[i].split("=", 2)
		n = decodeURIComponent(nv[0])
		v = decodeURIComponent(nv[1])

		if (!parms.hasOwnProperty(n))
			parms[n] = []
		parms[n].push(if nv.length == 2 then v else null)

	return parms

app.GetCookie = (name) ->
	name = name + "="
	cookiearray = decodeURIComponent(document.cookie).split(';')
	for cookie in cookiearray
		while cookie.charAt(0) == ' '
			cookie = cookie.substring(1)
		if cookie.indexOf(name) == 0
			return cookie.substring(name.length, cookie.length)
	return ""
app.CreateCookie = (name, value, expdays, update) ->
	if (app.GetCookie(name) != "") && !update
		return false
	else
		if expdays != null || ''
			expdate = new Date()
			expdate.setTime(expdate.getTime() + (expdays*24*60*60*1000))
			document.cookie = name + "=" + value + ";expires="+ expdate.toUTCString() + ";path=/"
		else
			document.cookie = name + "=" + value + ";path=/"
	return true
app.DeleteCookie = (name) ->
	if app.GetCookie(name) == ""
		return false
	else
		document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
	return true

app.ElementInViewport = (el) ->
	top = el.offsetTop
	height = el.offsetHeight
	
	while el.offsetParent
		el = el.offsetParent
		top += el.offsetTop
	
	return window.pageYOffset + window.innerHeight/2 > top && window.pageYOffset < (top + height)

app.GetSetId = (elem, prefix, idArray) ->
	if !elem.attr('id')
			id = prefix + idArray.length
			elem.attr('id',id)
			idArray.push(id)
		return id
	return elem.attr('id')

app.GetNRandomizedFromArray = (arr,n) ->
	len = arr.length
	if n > len
		n = len
	result = new Array(n)
	for i in [0..n-1]
		index = Math.floor(Math.random() * (len - i))
		tmp = arr[index]
		arr[index] = arr[len - i - 1]
		arr[len - i - 1] = tmp
		result[i] = tmp
	return result

# ##### GLOBAL #####

app.TouchDetectBinder = ->
	window.addEventListener 'touchstart', ->
		document.body.classList.remove('no-touch')
		app.isTouch = true
		return
	return

app.WindowScrollEventBinder = ->
	$(document).on 'scroll', (e) ->
		$(".ideasmodule_filter").trigger 'ideasmodulefilterscroll'
		$(".sidejumper").trigger 'sidejumperscroll'
		$("#header").trigger 'headerscroll'
	return

app.ScrollToElem = (elem, offset) ->
	offset = if offset then offset else 0
	window.scrollTo({
		top: parseInt($(elem).offset().top + offset,10), 
		left: 0,
		behavior: "smooth" 
	})
	return

app.pageScrollPos = 0
app.pageScrollInterval = null
app.ShowPagedarkener = (nofix) ->
	$("#pagedarkener").addClass('shown')
	app.pageScrollPos = $(window).scrollTop()
	$("#page").addClass('fixedscroll')
	$("#page_content").css('transform',"translateY(-" + app.pageScrollPos + "px)")
	if nofix
		$("#page").removeClass('fixedscroll')
		$("#page_content").css('transform',"")
	return true
app.HidePagedarkener = ->
	$("#pagedarkener").removeClass('shown')
	$("#page").removeClass('fixedscroll')
	$("#page_content").css('transform',"")
	$(window).scrollTop(app.pageScrollPos)
	return true

app.OpenOverlay = (content) ->
	$("#overlay_window_content").html(content)
	app.ShowPagedarkener()
	$("#overlay").addClass('open')
	return
app.CloseOverlay = ->
	$("#overlay").removeClass('open')
	app.HidePagedarkener()
	#$("#overlay_window_content").html("")
	return
app.OverlayCloserBinder = ->
	$("#overlay_window_closer").off('click').on 'click', (e) ->
		app.CloseOverlay()
		return
	return

app.HideVideooverlay = (videooverlay) ->
	$(videooverlay).find(".video_video").children("video")[0].pause()
	$(videooverlay).remove()
	app.HidePagedarkener()
	return
app.ShowVideooverlay = (videoelem) ->
	app.ShowPagedarkener()
	$("#app").append('<div class="videooverlay"><div class="videooverlay_window"><div class="videooverlay_window_closer"></div><div class="videooverlay_window_content">' + $(videoelem).clone().html() + '</div></div></div>')
	$("#app").find(".videooverlay_window_closer").off('click').on 'click', (e) ->
		e.preventDefault()
		app.HideVideooverlay($(this).closest(".videooverlay"))
		return
	app.VideoBinder($(".videooverlay_window_content .video"))
	return

app.OpenMainmenu = ->
	$("#mainmenu").addClass('open')
	return true
app.CloseMainmenu = ->
	$("#mainmenu").removeClass('open')
	return true

app.BurgermenuBinder = ->
	$("#burgermenu").off('click').on 'click', (e) ->
		e.preventDefault()
		if $(this).hasClass('act')
			app.HidePagedarkener()
			app.CloseMainmenu()
		else
			app.ShowPagedarkener()
			app.OpenMainmenu()
		$(this).toggleClass('act')
		return
	return true

app.HeaderScrollBinder = ->
	$("#header").off('headerscroll').on 'headerscroll', (e) ->
		if $(window).scrollTop() > app.oldScrollPos && $(window).scrollTop() > 10
			$("#header, #burgermenu").addClass('hide')
			$(".ideasmodule_filter").addClass('headerhidden')
		else
			$("#header, #burgermenu").removeClass('hide')
			$(".ideasmodule_filter").removeClass('headerhidden')
		app.oldScrollPos = $(window).scrollTop()
		return
	return

app.lottieAnimationIds = []
app.lottieAnimations = []
app.LottieAnimationBinder = (elem) ->
	id = app.GetSetId(elem, "lottieanimation_", app.lottieAnimationIds)
	app.lottieAnimations[id] = bodymovin.loadAnimation({
		container: document.getElementById(id),
		path: $(elem).attr('data-json'),
		renderer: 'svg',
		loop: false,
		autoplay: true
	})
	return

app.SlickSliderBinder = (elem) ->
	if elem.hasClass("storybox_overlay_slides")
		$(elem).slick({
			dots: false,
			infinite: false
		})
		$(elem).on 'beforeChange', (e, slick, currentSlide, nextSlide) ->
			prevSlide = app.lottieAnimations[$(this).find('.storybox_overlay_slides_slide.slick-current').prev(".storybox_overlay_slides_slide").find(".storybox_overlay_slides_slide_animation").attr('id')]
			nextSlide = app.lottieAnimations[$(this).find('.storybox_overlay_slides_slide.slick-current').next(".storybox_overlay_slides_slide").find(".storybox_overlay_slides_slide_animation").attr('id')]
			if prevSlide
				prevSlide.goToAndStop(0,true)
			if nextSlide
				nextSlide.goToAndStop(0,true)
			return
		$(elem).on 'afterChange', (e, slick, currentSlide, nextSlide) ->
			progress = (((currentSlide+1) / slick.slideCount) * 100)
			$(this).closest(".storybox_overlay").find(".progressbar_inner").css({
				'width': progress + '%'	
			})
			if $(this).find('.storybox_overlay_slides_slide.slick-current').find(".storybox_overlay_slides_slide_animation").length > 0
				app.lottieAnimations[$(this).find('.storybox_overlay_slides_slide.slick-current').find(".storybox_overlay_slides_slide_animation").attr('id')].play()
			return
	else
		$(elem).slick({
			dots: false,
			infinite: false
		})
	$(elem).find(".slick-arrow").each ->
		$(this).html('<svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" version="1.1" viewBox="0 0 23.1 37.9" xml:space="preserve"><defs/><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="6" d="M4.2 4.2L20.1 19 4.2 33.7"/></svg>')
		return
	return


# local Storage management
app.LocalstorageManagement = ->
	if typeof(Storage) != "undefined"
		app.bookmarks = if localStorage.mikabookmarks then JSON.parse(localStorage.mikabookmarks) else {"bookmarks":[]}
	else
		$("#header_bookmark, #mainmenu_nav_bookmarks").remove()
	return

# bookmarks
app.BookmarksBinder = ->
	if $("#bookmarks").length > 0
		if app.bookmarks.bookmarks.length > 0
			$("#bookmarks_empty").addClass('hidden')
			$("#bookmarks").append('<div id="bookmarks_list"><div class="wrapper"><div id="bookmarks_list_elems"></div></div></div>')
			for bookmark in app.bookmarks.bookmarks
				details = ''
				for detail in bookmark.details
					details += '<div class="ideabox_content_details_detail"><div class="ideabox_content_details_detail_headline">' + detail.headline + '</div><div class="ideabox_content_details_detail_text">' + detail.text + '</div></div>'
				tags = ''
				for tag in bookmark.tags
					tags += '<div class="tag ' + tag + '"></div>'
				$("#bookmarks_list_elems").append('<div class="ideabox" id="' + bookmark.id + '"><div class="ideabox_closer"></div><div class="ideabox_content"><div class="ideabox_content_overview"><div class="ideabox_content_overview_name">' + bookmark.name + '</div><div class="ideabox_content_overview_tags">' + tags + '</div><div class="ideabox_content_overview_short">' + bookmark.short + '</div><div class="ideabox_content_overview_image"><img src="' + bookmark.img.src + '" alt="' + bookmark.img.alt + '" title="' + bookmark.img.title + '"/></div></div><div class="ideabox_content_details">' + details + '</div></div><div class="ideabox_interaction"><div class="ideabox_interaction_bookmark"><div class="button transparent outline"><div class="button_content"><div class="button_content_text">Merken</div><div class="button_content_icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.774 18.464" class="icon_heartshape" fill="#fff" stroke="#fff" stroke-linejoin="round" stroke-width="1"><defs/><path d="M10.386 17.959h0v-.011c-.243-.25-4.67-4.806-7.3-7.44C.374 7.8-.259 4.755 1.929 2.215a4.9 4.9 0 016.505-.847 25.052 25.052 0 011.953 1.911 25.107 25.107 0 011.951-1.911 4.9 4.9 0 016.506.847c2.188 2.54 1.555 5.588-1.151 8.3a977.61 977.61 0 00-7.3 7.44v.011z"/></svg></div></div></div></div><a class="ideabox_interaction_download" href="' + bookmark.download + '" target="_blank"><div class="button transparent outline"><div class="button_content"><div class="button_content_text">Download</div><div class="button_content_icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 22.627" class="icon_download" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2" stroke-linejoin="round"><defs/><g transform="translate(1 1)"><path d="M263.354 2088.525h3.961v16.367h-15v-16.367h3.938" transform="translate(-252.315 -2084.264)"/><g transform="translate(3.629)"><path d="M255.824 2094.531l3.812 3.812 3.812-3.812" transform="translate(-255.824 -2084.122)"/><path d="M259.548 2101.523V2087.3" transform="translate(-255.736 -2087.301)"/></g></g></svg></div></div></div></a></div><div class="ideabox_handle"><div class="ideabox_handle_icon"></div></div></div>')
	return

# ##### ATOMS #####

# video
app.VideoBinder = (elem) ->
	if $(elem).hasClass('video')
		$(elem).children(".video_playbtn").off('click').on 'click', (e) ->
			e.preventDefault()
			$(this).parent(".video").children(".video_loaderimg").hide()
			$(this).hide()
			$(this).parent(".video").find(".video_video").children("video")[0].play()
			$(this).parent(".video").find(".video_video").children("video")[0].onpause = ->
				if !this.seeking
					$(this).closest(".video").children(".video_loaderimg").show()
					$(this).closest(".video").children(".video_playbtn").show()
				return
			return
	return

# soundbutton
app.SoundbuttonBinder = ->
	$(".soundbutton").each ->
		$(this).off('click').on 'click', (e) ->
			e.preventDefault()
			audioelem = $(this).find('audio')[0]
			if $(this).hasClass('act')
				audioelem.pause()
			else
				audioelem.currentTime = 0
				audioelem.play()
				$(audioelem).off('ended').on 'ended', (e) ->
					$(this).closest(".soundbutton").removeClass('act')
					return
			$(this).toggleClass('act')
			return
		return
	return

# soundslider
app.SoundsliderBinder = ->
	$(".soundslider").each ->
		sounds = $(this).find(".soundslider_audio audio").length
		$(this).find(".soundslider_range").attr('max',sounds+1).val(Math.round((sounds+1)/2))
		$(this).find(".soundslider_range").off('change').on 'change', (e) ->
			$(this).parent('.soundslider').find(".soundslider_audio audio").each ->
				$(this)[0].pause()
				return
			if (parseInt($(this).val(),10) > Math.round(parseInt($(this).attr('max')/2,10))) && (parseInt($(this).attr('max'),10) > 2)
				$(this).parent('.soundslider').find(".soundslider_audio audio").eq($(this).val() - 2)[0].play()
			else
				$(this).parent('.soundslider').find(".soundslider_audio audio").eq($(this).val() - 1)[0].play()
			if (parseInt($(this).val(),10) == Math.round(parseInt($(this).attr('max'),10)/2)) && (parseInt($(this).attr('max'),10) > 2)
				$(this).parent('.soundslider').find(".soundslider_audio audio").each ->
					$(this)[0].pause()
					return
			return
		return
	return

# audioimage
app.AudioimageBinder = ->
	$(".audioimage").each ->
		$(this).find(".audioimage_playbtn").off('click').on 'click', (e) ->
			e.preventDefault()
			if $(this).hasClass('act')
				$(this).closest(".audioimage").find(".audioimage_audio audio")[0].pause()
			else
				$(this).closest(".audioimage").find(".audioimage_audio audio")[0].play()
			$(this).toggleClass('act')
			return
		self = $(this)
		$(this).find(".audioimage_audio audio")[0].onpause = ->
			$(self).find(".audioimage_playbtn").removeClass('act')
			return
		return
	return


# ##### MOLECULES #####

# accordionbox
app.AccordionboxBinder = ->
	$(".accordionbox").each ->
		$(this).find('.accordionbox_header').off('click').on 'click', (e) ->
			e.preventDefault()
			$(this).closest('.accordionbox').toggleClass('open').find('.accordionbox_content').slideToggle('fast')
			return
		return
	return

# ideabox
app.ideaboxScrollInterval = null
app.ideaboxScrollDelay = 400
app.BookmarkIdea = (elem) ->
	details = []
	tags = []
	$(elem).find(".ideabox_content_details_detail").each ->
		details.push({"headline":$(this).find(".ideabox_content_details_detail_headline").text(),"text":$(this).find(".ideabox_content_details_detail_text").text()})
		return
	$(elem).find(".ideabox_content_overview_tags .tag").each ->
		tags.push($(this).attr('class').replace(/tag/g,"").trim())
		return
	newbookmark = {"id":$(elem).attr("id"),"name":$(elem).find(".ideabox_content_overview_name").text(),"tags":tags,"short":$(elem).find(".ideabox_content_overview_short").text(),"img":{"src":$(elem).find(".ideabox_content_overview_image img").attr("src"),"alt":$(elem).find(".ideabox_content_overview_image img").attr("alt"),"title":$(elem).find(".ideabox_content_overview_image img").attr("title")},"details":details,"download":$(elem).find(".ideabox_interaction_download").attr("href")}
	app.bookmarks.bookmarks.push(newbookmark)
	localStorage.mikabookmarks = JSON.stringify(app.bookmarks)
	return
app.UnbookmarkIdea = (id) ->
	i = 0
	for bookmark in app.bookmarks.bookmarks
		if bookmark.id == id
			app.bookmarks.bookmarks.splice(i,1)
		i++
	localStorage.mikabookmarks = JSON.stringify(app.bookmarks)
	return
app.IdeaboxBinder = ->
	$(".ideabox").each ->
		# handle binder
		$(this).find(".ideabox_handle").off('click').on 'click', (e) ->
			$(this).closest(".ideabox").toggleClass('open')
			window.clearInterval(app.ideaboxScrollInterval)
			if $(this).closest(".ideabox").hasClass('open')
				self = $(this)
				app.ideaboxScrollInterval = window.setInterval( ->
					window.clearInterval(app.ideaboxScrollInterval)
					scrollOffset = if $(window).width() < 768 then (($("#header").height() * 3) * (-1)) else (($("#header").height() * 2) * (-1))
					app.ScrollToElem($(self).closest(".ideabox"), scrollOffset)
					return
				, app.ideaboxScrollDelay)
			return
		
		# closer binder
		$(this).find(".ideabox_closer").off('click').on 'click', (e) ->
			$(this).closest('.ideabox').removeClass('open')
			return
		
		# bookmark binder	
		# if Storage is not available - disable bookmark button
		if typeof(Storage) == "undefined"
			$(this).find(".ideabox_interaction_bookmark .button").addClass('disabled')
		else
			# activate bookmarked items
			for bookmark in app.bookmarks.bookmarks
				$("#" + bookmark.id).find(".ideabox_interaction_bookmark").addClass('act').find(".button_content_text").text("Gemerkt")
			# bind bookmark buttons
			$(this).find(".ideabox_interaction_bookmark").off('click').on 'click', (e) ->
				e.preventDefault()
				if !$(this).hasClass('act')
					app.BookmarkIdea($(this).closest(".ideabox"))
					$(this).addClass('act').find(".button_content_text").text("Gemerkt")
				else
					app.UnbookmarkIdea($(this).closest(".ideabox").attr('id'))
					$(this).removeClass('act').find(".button_content_text").text("Merken")
					if $(this).closest('#page').find("#bookmarks").length > 0
						$(this).closest(".ideabox").remove()
						if $("#bookmarks_list").find(".ideabox").length < 1
							$("#bookmarks_list").remove()
							$("#bookmarks_empty").removeClass('hidden')
							app.ScrollToElem($("#bookmarks"),$(window).height() * (-1))
				return
		
		# share binder
		###
		$(this).find(".ideabox_interaction_sh").off('click').on 'click', (e) ->
			e.preventDefault()
			# make link
			link = window.location.href + "#" + $(this).closest(".ideabox").attr('id')
			
			# make fb share
			encodedlink = link.replace("/","%2F").replace(":","%3A").replace("?","%3F")
			$(this).attr("target","_blank").attr("href","https://www.facebook.com/sharer/sharer.php?u=" + encodedlink + "&amp;src=sdkpreparse").addClass("fb-xfbml-parse-ignore")
			window.open($(this).attr('href'), "Teilen", "height=460,width=560")
			return
		return
		###
	
	# check for ideabox hash id in url
	id = window.location.hash
	if $(id).length > 0
		if $(id).hasClass('ideabox')
			$(id).find(".ideabox_handle").trigger('click')
	
	return

# sideflaps
app.SideflapsBinder = ->
	$(".sideflaps").each ->
		$(this).find(".sideflaps_flap").each ->
			$(this).find(".sideflaps_flap_icon").off('click').on 'click', (e) ->
				e.preventDefault()
				app.ShowPagedarkener(true)
				$(this).closest('.sideflaps').find('.sideflaps_flap').removeClass('open')
				$(this).closest(".sideflaps_flap").addClass('open')
				return
			$(this).find(".sideflaps_flap_handle").off('click').on 'click', (e) ->
				e.preventDefault()
				app.HidePagedarkener()
				$(this).closest(".sideflaps_flap").removeClass('open')
				return
			return
		return
	return

# understandbox
app.UnderstandboxBinder = ->
	$(".understandbox").each ->
		$(this).find(".understandbox_handle").off('click').on 'click', (e) ->
			e.preventDefault()
			$(this).closest(".understandbox").toggleClass('open').find(".understandbox_toggle").slideToggle()
			return
		return
	return

# videobox
app.videoboxScrollInterval = null
app.videoboxScrollDelay = 400
app.VideoboxBinder = ->
	$(".videobox").each ->
		$(this).find(".videobox_handle").off('click').on 'click', (e) ->
			$(this).closest(".videobox").toggleClass('open')
			window.clearInterval(app.videoboxScrollInterval)
			if $(this).closest(".videobox").hasClass('open')
				self = $(this)
				app.videoboxScrollInterval = window.setInterval( ->
					window.clearInterval(app.videoboxScrollInterval)
					scrollOffset = if $(window).width() < 768 then (($("#header").height() * 3) * (-1)) else (($("#header").height() * 2) * (-1))
					app.ScrollToElem($(self).closest(".videobox"), scrollOffset)
					return
				, app.videoboxScrollDelay)
			return
		$(this).find(".videobox_closer").off('click').on 'click', (e) ->
			$(this).closest('.videobox').removeClass('open')
			return
		$(this).find(".videobox_content_overview_preview_playicon").off('click').on 'click', (e) ->
			e.preventDefault()
			app.ShowVideooverlay($(this).closest(".videobox").find(".videobox_overlaycontent"))
			return
		return
	return

# videotext
app.VideotextBinder = ->
	$(".videotext").each ->
		app.VideoBinder($(this).find(".videotext_content_video .video"))
		return
	return

# sideimagetext
app.SideimagetextBinder = ->
	$(".sideimagetext").each ->
		playbox = $(this).closest(".discovermodule_content_main_play")
		playbox.find(".discovermodule_content_main_play_headline, .icontextlist").addClass('sitpad')
		return
	return

# sidejumpermodule
app.SidejumpermoduleScrollCheck = (elem,sidejumperids) ->
	for id in sidejumperids
		if app.ElementInViewport(document.getElementById(id))
			$(elem).find(".sidejumper_button").each ->
				if $(this).attr('href') == "#" + id
					if !$(this).hasClass('act')
						$(elem).find(".sidejumper_button").removeClass('act')
						$(this).addClass('act')
				return
	return
app.SidejumpermoduleBinder = ->
	$(".sidejumper").each ->
		sidejumperids = []
		$(this).find(".sidejumper_button").each ->
			if $($(this).attr('href')).length == 1
				sidejumperids.push($(this).attr('href').replace(/#/g,""))
				$(this).off('click').on 'click', (e) ->
					e.preventDefault()
					app.ScrollToElem($($(this).attr('href')), (window.innerHeight/2 - $("#header").height()) * (-1))
					return
			else
				$(this).remove()
			return
		if $(this).find(".sidejumper_button").length < 2
			$(this).remove()
		$(this).off('sidejumperscroll').on 'sidejumperscroll', (e) ->
			app.SidejumpermoduleScrollCheck($(this),sidejumperids)
			return
		# initial check
		app.SidejumpermoduleScrollCheck($(this),sidejumperids)
	return

# videocard
app.VideocardBinder = ->
	$(".videocard").each ->
		$(this).find(".videocard_preview").off('click').on 'click', (e) ->
			e.preventDefault()
			app.ShowVideooverlay($(this).closest(".videocard").find(".videocard_video"))
			return
		return
	return

# videocardexp
app.VideocardexpBinder = ->
	$(".videocardexp").each ->
		$(this).find(".videocardexp_handle").off('click').on 'click', (e) ->
			$(this).closest(".videocardexp").toggleClass('open')
			return
		$(this).find(".videocardexp_preview").off('click').on 'click', (e) ->
			e.preventDefault()
			app.ShowVideooverlay($(this).closest(".videocardexp").find(".videocardexp_video"))
			return
		return
	return

# ##### ORGANISMS #####

# numberedaccordion
app.NumberedAccordionBinder = ->
	$(".numberedaccordion").each ->
		$(this).find(".numberedaccordion_content_elem").each ->
			$(this).find(".numberedaccordion_content_elem_number").html($(this).index() + 1)
			if $(this).find(".numberedaccordion_content_elem_headline").text() == ""
				$(this).addClass('nohl')
			return
		return
	return

# storybox
app.StoryboxBinder = ->
	$(".storybox").each ->
		$(this).find(".storybox_box_button .button").off('click').on 'click', (e) ->
			e.preventDefault()
			app.lottieAnimationIds = []
			app.lottieAnimations = []
			app.OpenOverlay($(this).closest(".storybox").find(".storybox_overlay").clone())
			$("#overlay .storybox_overlay_slides_slide_animation").each ->
				app.LottieAnimationBinder($(this))
				return
			$("#overlay .storybox_overlay_slides_slide_video").each ->
				app.VideoBinder($(this).find(".video"))
				return
			slidecount = $("#overlay .storybox_overlay_slides_slide").length
			if slidecount > 1
				app.SlickSliderBinder($("#overlay").find(".storybox_overlay_slides"))
				$("#overlay .storybox_overlay_progress .progressbar_inner").css("width",((1/slidecount)*100) + "%")
			else
				$("#overlay .storybox_overlay").addClass('noprogress').find(".storybox_overlay_progress").remove()
			return
		return
	return

# downloadslider
app.DownloadsliderBinder = ->
	$(".downloadslider").each ->
		app.SlickSliderBinder($(this).find(".downloadslider_content_slider"))
		return
	return

# ideasmodule
app.minimumIdeas = 8
app.LoadIdeaItems = (elem) ->
	loadedIdeas = parseInt($(elem).attr('data-loaded'),10)
	maxIdeas = $(elem).find(".ideabox").length
	ideaIds = []
	$(elem).find(".ideabox.hidden").each ->
		ideaIds.push($(this).attr('id'))
		return
	randomizedArray = app.GetNRandomizedFromArray(ideaIds,app.minimumIdeas)
	for id in randomizedArray
		#$(elem).find(".ideabox").eq(i).removeClass('hidden')
		$("#"+id).removeClass('hidden')
		$(elem).find(".ideasmodule_ideas").append($("#"+id))
	if (loadedIdeas + app.minimumIdeas) > maxIdeas
		$(elem).find(".ideasmodule_loadmore").remove()
		$(elem).attr('data-loaded',maxIdeas)
	else
		$(elem).attr('data-loaded',loadedIdeas + app.minimumIdeas)
	return
app.ResetIdeasFilter = (elem) ->
	$(elem).find(".ideabox").removeClass('nomatch')
	app.ScrollToElem(elem,0)
	return
app.ApplyIdeasFilter = (elem) ->
	filter = []
	$(elem).find(".ideasmodule_filter_content_filterlist label").each ->
		if $(this).find("input[type=checkbox]").prop("checked")
			filter.push($(this).find(".filtericon").attr('class').replace(/filtericon/g,"").trim())
		return
	$(elem).find(".ideabox").each ->
		$(this).removeClass('nomatch')
		if filter.length > 0
			tagmatch = false
			$(this).find(".ideabox_content_overview_tags .tag").each ->
				for tag in filter
					if $(this).hasClass(tag)
						tagmatch = true
				return
			if !tagmatch
				$(this).addClass('nomatch')
		return
	app.ScrollToElem(elem,0)
	return
app.IdeasmoduleBinder = ->
	$(".ideasmodule").each ->
		# replace load more button icon-version with text-version
		$(this).find(".ideasmodule_loadmore .button").removeClass('icononly').find(".button_content").append('<div class="button_content_text">Weitere Ideen</div>').find(".button_content_icon").remove()
		
		$(this).find(".ideasmodule_filter").off('ideasmodulefilterscroll').on 'ideasmodulefilterscroll', (e) ->
			if $(this).closest('.ideasmodule').offset().top - $("#header").height() < $(document).scrollTop()
				$(this).closest(".ideasmodule").css('padding-top',$(this).outerHeight() + 'px')
				$(this).addClass('fixed')
			else
				$(this).closest(".ideasmodule").css('padding-top',0)
				$(this).removeClass('fixed').removeClass('expanded')
			return
		$(this).find(".ideasmodule_filter").off('click').on 'click', (e) ->
			#e.preventDefault()
			if $(this).hasClass('fixed')
				$(this).addClass('expanded')
		$(this).find(".ideasmodule_filter_closer").off('click').on 'click', (e) ->
			e.preventDefault()
			e.stopPropagation()
			$(this).closest(".ideasmodule_filter").removeClass('expanded')
			return
		$(this).find(".ideasmodule_filter_content_filterlist .checkbox").each ->
			$(this).find("input").off('change').on 'change', (e) ->
				if $(this).closest(".ideasmodule_filter_content_filterlist").find(".checkbox input:checked").length > 0
					$(this).closest(".ideasmodule_filter_content").find(".ideasmodule_filter_content_interaction_reset .button").removeClass('disabled')
				else
					$(this).closest(".ideasmodule_filter_content").find(".ideasmodule_filter_content_interaction_reset .button").addClass('disabled')
				return
			return
		$(this).find(".ideasmodule_filter_content_interaction_reset .button").off('click').on 'click', (e) ->
			e.preventDefault()
			if !$(this).hasClass('disabled')
				$(this).addClass('disabled')
				$(this).closest(".ideasmodule").find(".ideasmodule_filter_content_filterlist .checkbox input").prop('checked',false)
				app.ResetIdeasFilter($(this).closest(".ideasmodule"))
			return
		$(this).find(".ideasmodule_filter_content_interaction_confirm .button").off('click').on 'click', (e) ->
			e.preventDefault()
			app.ApplyIdeasFilter($(this).closest(".ideasmodule"))
			return
		$(this).find(".ideasmodule_loadmore").off('click').on 'click', (e) ->
			e.preventDefault()
			app.LoadIdeaItems($(this).closest(".ideasmodule"))
			return
		
		maxIdeas = $(this).find(".ideabox").length
		if maxIdeas < app.minimumIdeas
			$(this).find(".ideasmodule_loadmore").remove()
		else
			$(this).find(".ideabox").addClass('hidden')
			
			id = window.location.hash
			if $(id).length > 0
				if $(id).hasClass('ideabox')
					$(id).removeClass('hidden')
					
			$(this).attr('data-loaded',0)
			$(this).find(".ideasmodule_loadmore").trigger 'click'
		
		return
	return

# contactform
app.ContactformBinder = ->
	$(".wpcf7").each ->
		$(this).addClass('contactmodule_content_form').closest(".richtext").removeClass('richtext').addClass('contactmodule').prepend('<div class="contactmodule_bgrd"><div class="bgrd_wave_desktop"></div><div class="bgrd_wave_mobile"></div></div>').find(".wrapper").addClass('contactmodule_content').prepend('<div class="contactmodule_content_headline">Kontakt</div>')
		$(this).find("label").each ->
			if $(this).find("input[type=checkbox]").length > 0
				$(this).addClass('checkbox').append('<div class="checkmark"></div>')
				$(this).closest(".wpcf7-form-control-wrap").wrap('<div class="formrow" style="display:flex;justify-content:center;"></div>')
			else
				$(this).find("input[type=text], input[type=email], textarea").attr('placeholder',$(this).text())
				$(this).wrap('<div class="formrow"></div>')
			return
		$(this).find("input[type=submit]").wrap('<div class="formrow" style="display:flex;justify-content:center;"></div>')
		return
	return

# ideasshort
app.IdeasshortmoduleBinder = ->
	$(".ideasshort").each ->
		$(this).find(".ideaminibox").each ->
			if $(this).attr('id')
				link = $(this).find("a").attr('href')
				link = link.substr(0,link.length-1) + link.substr(link.length-1,link.length).replace(/\//g, "")
				$(this).find("a").attr('href',link+"#"+$(this).attr('id'))
			return
		return
	return


# ##### MAIN #####

app.Main = ->
	# ### GLOBAL ###
	app.TouchDetectBinder()
	app.WindowScrollEventBinder()
	app.BurgermenuBinder()
	app.HeaderScrollBinder()
	app.OverlayCloserBinder()
	app.LocalstorageManagement()
	app.BookmarksBinder()
	
	# ### ATOMS ###
	app.SoundbuttonBinder()
	app.SoundsliderBinder()
	app.AudioimageBinder()
	
	# ### MOLECULES ###
	app.AccordionboxBinder()
	app.IdeaboxBinder()
	app.SideflapsBinder()
	app.UnderstandboxBinder()
	app.VideoboxBinder()
	app.StoryboxBinder()
	app.VideotextBinder()
	app.SideimagetextBinder()
	app.SidejumpermoduleBinder()
	app.VideocardBinder()
	app.VideocardexpBinder()
	
	# ### ORGANISMS ###
	app.NumberedAccordionBinder()
	app.DownloadsliderBinder()
	app.IdeasmoduleBinder()
	app.ContactformBinder()
	app.IdeasshortmoduleBinder()
	return

app.Main()